export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";